import { render, staticRenderFns } from "./WQtypeBigtext.vue?vue&type=template&id=39044cbe&"
import script from "./WQtypeBigtext.vue?vue&type=script&lang=ts&"
export * from "./WQtypeBigtext.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports